/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WidgetComposition {
    getFixupPrototypeFunction() { return WidgetComposition.fixupPrototype; }

    static newInstance(model: Partial<WidgetComposition>): WidgetComposition {
        let obj = Object.assign(new WidgetComposition(), model);
        WidgetComposition.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WidgetComposition>): WidgetComposition {
        if (!model) return null;
        return WidgetComposition.newInstance(<WidgetComposition> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WidgetComposition) {
        if (!obj) return;

        models.WidgetComposition.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WidgetComposition): boolean {
        Object.setPrototypeOf(obj, WidgetComposition.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.config) {
            models.WidgetConfiguration.fixupPrototype(this.config);
        }
        if (this.outline) {
            models.WidgetOutline.fixupPrototype(this.outline);
        }
    }

    config: models.WidgetConfiguration;

    outline: models.WidgetOutline;

}
